import Header from "./Header";
import Footer from "./Footer";
import Quotes from "./Quotes";
import home_json from "../data/home.json";
import translatedHeading from "../utils/util";
import parse from "html-react-parser";
import brahm_vidyalay_rajpur_board from "../images/brahm_vidyalay_rajpur_board.jpeg";
import "../styles/App.css";


const Home = () => {
  const currentLanguageVal = localStorage.getItem("language");
  const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";
  const home_page_json_data = home_json;
  return (
    <>
      <Header />
      <div className="page-header">{translatedHeading("Home")}</div>
      <Quotes/>
      <div className="home">
        {home_page_json_data.map((item, index) => {
          let tag = item.tag;
          let value =
            currentLanguage === "en" ? item.value : item["value-hindi"];
          if (tag === "h3") {
            return <h3 key={index}>{parse(value)}</h3>;
          } else if (tag === "p") {
            return <p key={index}>{parse(value)}</p>;
          } else if (tag === "div" && typeof value !== "string") {
            return (
              <div key={index} className={item.className}>
                <img
                  className={value.img.className}
                  src={
                    value.img.src === "brahm_vidyalay_rajpur_board"
                      ? brahm_vidyalay_rajpur_board
                      : ""
                  }
                  alt={value.img.alt}
                />
                <p>{value.text}</p>
              </div>
            );
          }
        })}
      </div>
      <Footer />
    </>
  );
};
export default Home;
